module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExtIt.e2bc3f1.eot";